<!--折扣类型管理-->
<template>
<div>
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-button style="margin-bottom:5px;" @click="showAddDiscountPage()" type="primary">新增折扣</el-button>
    </el-col>
    <el-table v-loading="listLoading" :data="tableData" style="width: 100%" class="info">
        <el-table-column sortable prop="id" label="折扣编号" min-width="100px">
        </el-table-column>
        <el-table-column sortable prop="name" label="折扣名称" min-width="180px">
        </el-table-column>
        <el-table-column prop="remark" label="折扣说明" min-width="180px" sortable>
        </el-table-column>
        <el-table-column prop="addTime" label="添加时间" min-width="150px" sortable>
        </el-table-column>
        <el-table-column prop="editTime" label="修改时间" min-width="180px" sortable>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="150px">
            <template slot-scope="scope">
                <el-button @click="editDiscountEvent(scope.$index, scope.row)" size="small">编辑</el-button>
                <el-button @click="delDiscountEvent(scope.$index, scope.row)" type="danger" size="small">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
    <el-col :span="24" class="toolbar" style="text-align:right">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totals">
        </el-pagination>
    </el-col>
    <!--新增折扣-->
    <el-dialog title="新增折扣" :visible.sync="addFormVisible" :close-on-click-modal="true">
        <el-form :model="addForm" :rules="rules" ref="addForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="折扣名称" prop="name">
                <el-input v-model="addForm.name"></el-input>
            </el-form-item>
            <el-form-item label="折扣说明">
                <el-input v-model="addForm.remark" type="textarea" :rows="3" placeholder="请输入内容"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" style="text-align:right" class="dialog-footer">
            <el-button @click.native="close()">取消</el-button>
            <el-button type="primary" @click.native="addDiscountAction('addForm')">{{save}}</el-button>
        </div>
    </el-dialog>
    <!--修改折扣-->
    <el-dialog title="编辑折扣" :visible.sync="editFormVisible" :close-on-click-modal="true">
        <el-form :model="editForm" :rules="rules" ref="editForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="折扣名称" prop="name">
                <el-input v-model="editForm.name"></el-input>
            </el-form-item>
            <el-form-item label="折扣说明">
                <el-input v-model="editForm.remark" type="textarea" :rows="3" placeholder="请输入内容"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" style="text-align:right" class="dialog-footer">
            <el-button @click.native="close()">取消</el-button>
            <el-button type="primary" @click.native="editDiscountAction('editForm')">{{save}}</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
//导入api
import util from '../../common/js/util'
import constant from '../../common/js/constant'
import {
    getDiscountListPage,
    addDiscount,
    editDiscount,
    delDiscount
} from '../../api/api'
export default {
    data() {
        return {
            //弹窗显示状态
            title: '',
            currentPage: 1, //当前页
            totals: 1, //总数据条数
            tableData: [], //数据
            pageSize: 10,
            listLoading: false,
            type: false,
            save: '保存',
            addFormVisible: false,
            addForm: {
                name: "",
                remark: ""
            },
            editFormVisible: false,
            editForm: {
                id: "",
                name: "",
                remark: ""
            },
            rules: {
                name: [{
                        required: true,
                        message: '折扣名称不能为空',
                        trigger: 'blur'
                    },
                    {
                        min: 2,
                        max: 50,
                        message: '长度在 2 到 50 个字符',
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    mounted() {
        //默认查询数据
        this.getlist();
    },
    methods: {
        addDiscountAction() {
            this.$refs["addForm"].validate((valid) => {
                if (valid) {
                    var param = this.addForm;
                    addDiscount(param).then((res) => {
                        if (res.code == 0) {
                            this.$message({
                                message: "折扣添加成功",
                                type: 'success',
                            });
                            this.addFormVisible = false;
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                        }
                        this.getlist();
                    });
                }
            });
        },
        editDiscountAction() {
            this.$refs["editForm"].validate((valid) => {
                if (valid) {
                    var param = this.editForm;
                    editDiscount(param).then((res) => {
                        if (res.code == 0) {
                            this.$message({
                                message: "折扣修改成功",
                                type: 'success',
                            });
                            this.editFormVisible = false;
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                        }
                        this.getlist();
                    });
                }
            });
        },
        editDiscountEvent(index, row) {
            //修改数据
            this.editFormVisible = true;
            this.editForm.id = row.id;
            this.editForm.name = row.name;
            this.editForm.remark = row.remark;
        },
        getlist() {
            //参数列表
            this.listLoading = true;
            let param = {
                pageNum: this.currentPage,
                pageSize: this.pageSize
            };
            getDiscountListPage(param).then((res) => {
                this.tableData = res.data.list;
                this.totals = res.data.total;
                this.listLoading = false;
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getlist();
        },
        handleCurrentChange(val) {
            //分页查询
            this.currentPage = val;
            this.getlist();
        },
        showAddDiscountPage() {
            //添加折扣
            //清空输入框
            this.addFormVisible = true;
            this.addForm.name = "";
            this.addForm.remark = "";
        },
        resetForm(formName) {
            //还原输入框
            this.$refs[formName].resetFields();
        },
        close() {
            this.addFormVisible = false;
            this.editFormVisible = false;
        },
        delDiscountEvent(index, value) {
            //删除折扣
            this.$confirm('您将删除指定折扣, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var param = {
                    discountId: value.id,
                };
                delDiscount(param).then((res) => {
                    if (res.code == 0) {
                        this.$message({
                            message: "折扣删除成功",
                            type: 'success'
                        });
                        this.getlist();
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// discountKind.vue?1d76b405